module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-right-d3cbcb03.svg";